<script>
  import GallerySeries from 'src/pc/pages/GallerySeries'
  import PageLayout from '../layouts/PageLayout'
  export default {
    extends: GallerySeries,
    components: {
      PageLayout,
    },
    computed: {
      getAccess() {
        return 'mobile'
      }
    }
  }
</script>

<style>
  .gallery_series {
    top: 0 !important;
  }
  .gallery_series .title {
    width: 100vw;
    height: 100px;
    margin-bottom: 30px !important;
  }
  .gallery_series .title_top {
    width: 100vw;
    height: 100px;
    padding: 20px;
    justify-content: center;
  }
  .gallery_series .title_top:before {
    width: 28px;
    height: 30px;
    margin-right: 8px;
  }
  .gallery_series .title_top p {
    font-size: 34px;
  }
	.gallery_series .gallery_sch {
		text-align: left;
	}
	.gallery_series .gallery_sch h3 {
		display: block;
		position: relative;
		font-size: 18px;
		line-height: 1.4em;
		margin-bottom: 10px;
	}
	.gallery_series .gallery_sch h3 em {
		font-size: 10px;
		padding: 0 10px;
	}
	.gallery_series .gallery_sch .sch_box {
		width: 80%;
	}
	.gallery_series .gallery_sch .sch_box input {
		width: calc(100% - 70px);
		font-size: 14px;
	}
	.gallery_series .gallery_sch .sch_btn {
		width: 70px;
		font-size: 13px;
		line-height: 38px;
		padding: 0;
	}
	.gallery_series .gallery_sch .reset {
		width: 18%;
		font-size: 13px;
		line-height: 38px;
		padding: 0;
	}
	.gallery_series .list_gallery {
		width: 100vw;
		margin-left: -20px;
	}
  .gallery_series .list_gallery ul {
		height: unset;
	}
	.gallery_series .list_gallery li {
		width: 100vw;
		height: 80vw;
		margin: 0;
	}
	.gallery_series .list_gallery li .subj {
		padding: 40px 15px 10px 15px;
	}
	.gallery_series .list_gallery li .subj h5 {
		font-size: 18px;
		line-height: 1.4em;
	}
	.gallery_series .list_gallery li .subj h6 {
		font-size: 13px;
	}
</style>
